import type { Extension, ForgeUICustomContentExtensionType } from '../types';

export const getAppId = (app: Extension): string | undefined => {
	if (!app?.id) {
		return;
	}

	const [, id] = app.id.split('/');
	return id;
};

export const getModuleKey = (module: Extension): string | undefined => {
	if (!module.id) {
		return;
	}

	const parts = module.id.split('/');
	return parts[parts.length - 1];
};

export const getCustomContentType = (app: ForgeUICustomContentExtensionType): string => {
	return `forge:${getAppId(app)}:${app.environmentId}:${getModuleKey(app)}`;
};
